import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavigationService } from 'src/app/providers/navigation.service';
import { SharedService } from '../../providers/shared.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'sm-activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.scss']
})
export class ActivityComponent implements OnInit, OnDestroy {
  // clickEventSubscription: Subscription;
  constructor(private _navService: NavigationService, private sharedService: SharedService) { 
    this._navService.hideSidebarAndNav = false;
    // this.clickEventSubscription = this.sharedService.getClickEvent().subscribe(() => {
    //   this.ngOnInit();
    // })
    
  }

  ngOnInit(): void {


  }

  ngOnDestroy(): void {
    // this.clickEventSubscription.unsubscribe()
  }

}
